import { render } from "./LogOutButton.vue?vue&type=template&id=63bdc68c"
import script from "./LogOutButton.vue?vue&type=script&lang=js"
export * from "./LogOutButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__